const useScorecardConfigurationStyles = () => {
    return {
        headerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            p: 1.5,
        },
        rowStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
        },
        contentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            p: 1.5,
            gap: 1,
            overflowY: 'auto',
            height: `calc(100dvh - 340px)`
        }
    };
};
export default useScorecardConfigurationStyles;
